module.exports = __webpack_public_path__ + "img/nuts.9f2e4693.jpg";